import { useEpisodeOtt } from './use-episode-ott';

export const useEpisodeStreams = (contentId: string) => {
    const episodeOtt = useEpisodeOtt(contentId);

    return episodeOtt?.onlineStreams?.streams;
};
